import type { FC } from "react";

const KemMedicalDisclaimer: FC = () => (
  <p className="px-1 pt-2 text-center text-xs">
    Remember that AI can make mistakes. Verify any health advice with your
    doctor or mDoc health coach.
  </p>
);

export default KemMedicalDisclaimer;
